import script from "./AnnouncementsEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnouncementsEdit.vue?vue&type=script&setup=true&lang=js"

import "./AnnouncementsEdit.vue?vue&type=style&index=0&id=5cf0ae6e&lang=scss"

const __exports__ = script;

export default __exports__